import React from 'react';

import styles from './Spinner.module.css';

const Spinner = (props) => (
    <div className={styles.loader}>Loading...</div>
);

export default Spinner;